import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const SchedulePage = styled.div`
    background-color: ${COLORS.BgMain};
    display: block;
    flex-grow: 1;
    width: 100%;
`;

export const ScheduleContainer = styled.div`
    padding: 0 7%;
    margin: 0 auto 108px;
    max-width: 1440px;
    width: 100%;

    @media screen and (max-width: 859px) {
        padding: 0 15px;
    }
`;

export const ScheduleControls = styled.section`
    display: flex;
    margin-top: 32px;
    position: relative;
    width: 100%;

    @media only screen and (max-width: 1023px) {
        margin-top: 27px;
    }

    @media only screen and (max-width: 767px) {
        flex-direction: column;
        margin-top: 27px;
    }
`;

export const ScheduleControlSearch = styled.div`
    flex-shrink: 0;
    margin-right: 32px;
    width: 320px;

    @media only screen and (max-width: 1023px) {
        width: calc(50% - 16px);
    }

    @media only screen and (max-width: 767px) {
        margin-right: 0;
        margin-bottom: 33px;
        width: 100%;
    }

    & > div {
        max-width: none;
    }
`;

export const ScheduleControlCategory = styled.div`
    flex-shrink: 0;
    width: 290px;

    @media only screen and (max-width: 1023px) {
        width: calc(50% - 16px);
    }

    @media only screen and (max-width: 767px) {
        width: 100%;
    }
`;

export const ScheduleChannels = styled.section`
    align-items: stretch;
    display: flex;
    flex-wrap: wrap;
    margin-top: 46px;
    width: 100%;
`;

export const ScheduleTabs = styled.section`
    margin-top: 32px;
    width: 100%;
`;

export const ScheduleShowMore = styled(BaseButton)`
    display: none;
    width: 100%;

    @media only screen and (max-width: 1023px) {
        display: inline-block;
    }
`;

export const Description = styled(ScheduleContainer)`
    display: block;
    white-space: pre-line;
    margin: 16px auto 64px;
    ${Paragraph4} {
        width: 66.666%;
        color: ${COLORS.TextInfo};
    }
    @media (max-width: ${wideBreakpoints.laptop}) {
        ${Paragraph4} {
            width: 100%;
        }
    }
`;
